'use strict';

function ctrl($scope, $location, Global, $http, timeFormat, fetchStream, socketIo, settings, usSpinnerService, ngDialog) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    $scope.data = {};
    $scope.infoData = {}

    socketIo('/api/ioc_notifications/ioc_events_drilldown').then(function (socket) {
        var host = {
            ip : "",
            hostname : ""
        }
        if ($location.$$search.vector === "outbound") {
            host.ip = $location.$$search.orig_ip
            host.hostname = $location.$$search.orig_hostname
        } else{
            host.ip = $location.$$search.resp_ip
            host.hostname = $location.$$search.resp_hostname
        }
        /////////////////
        /// USER INFO ///
        /////////////////
        new fetchStream('user_info', socket, host).then(function (result) {
        }, function (err) {
        }, function (result) {
            if (result.rows[0]) {
                $scope.infoData = result.rows[0];
                $scope.infoData.last = timeFormat($scope.infoData.time, "tables");
                host.sensor = $scope.infoData.sensor;
                if ($location.$$search.resp_hostname) {
                    $scope.infoData.resp_hostname = $location.$$search.resp_hostname;
                }
                if ($location.$$search.orig_hostname) {
                    $scope.infoData.orig_hostname = $location.$$search.orig_hostname;
                }
                new fetchStream('ioc_desc', socket, host).then(function (result) {
                }, function (err) {
                }, function (result) {
                    if (result.rows.length > 0) {
                        $scope.infoData.desc = result.rows[0].description;
                    }
                })
                new fetchStream('ioc_info', socket, host).then(function (result) {
                }, function (err) {
                }, function (result) {
                    $scope.child_ioc = result;
                })
            }
        })



        let id = 0;
        model.drillDownComplete = false;
        model.iocSwimlane = false;
        let finished = 0;
        $scope.crossfilterData = new crossfilter();
        // $scope.lanes = ['IOC', 'IOC Severity', 'Conn', 'Applications', 'DNS', 'HTTP', 'SSL', 'Email', 'File', 'Endpoint'];
        // let lanes = ['ioc', 'ioc_severity', 'conn', 'application', 'dns', 'http', 'ssl', 'email', 'file', 'endpoint'];
        // let lanes_drill = ['ioc', 'ioc_severity', 'conn_drill', 'application_drill', 'dns_drill', 'http_drill', 'ssl_drill', 'email_drill', 'file_drill', 'endpoint_drill'];
        $scope.lanes = ['IOC', 'IOC Severity', 'Conn', 'Applications', 'DNS', 'HTTP', 'SSL', 'File'];
        let lanes = ['ioc', 'ioc_severity', 'conn', 'application', 'dns', 'http', 'ssl', 'file'];
        let lanes_drill = ['ioc', 'ioc_severity', 'conn_drill', 'application_drill', 'dns_drill', 'http_drill', 'ssl_drill', 'file_drill'];

        $scope.$broadcast('startSpinner');
        // $scope.$broadcast('stopSpinner');
        for (let i = 0, len = lanes.length; i < len; i++) {
            new fetchStream(lanes[i], socket, host).then(function (result) {
                finished ++;
                if (finished >= lanes.length) {
                    $scope.$broadcast('stopSpinner');
                }
            }, function (err) {
            }, function (result) {
                result.rows.forEach(function (child) {
                    child.dd = timeFormat(child.time, 'strdDateObj');
                    child.id = id;
                    id++;
                    child.deep = false; // important for our filtering of deep items
                })
                $scope.crossfilterData.add(result.rows);

                if (typeof $scope.crossfilterData.launched === "undefined") {
                    $scope.$broadcast('laneGraph');
                } else {
                    $scope.updatedSwimLaneData(result.rows);
                }
            })
        }

        $scope.getDrillDown = function (params, time) {
            finished = 0;
            if (!params) {
                params = host
            } else {
                params.ip = host.ip;
                params.hostname = host.hostname;
            }
            $scope.$broadcast('startSpinner');
            for (let j = 0, leng = lanes_drill.length; j < leng; j++) {
                new fetchStream(lanes_drill[j], socket, params, time).then(function (result) {
                    finished ++;
                    if (finished >= lanes_drill.length) {
                        $scope.$broadcast('stopSpinner');
                    }
                }, function (err) {
                }, function (result) {
                    result.rows.forEach(function (child) {
                        child.dd = timeFormat(child.time, 'strdDateObj');
                        child.id = id;
                        id++;
                        child.deep = true; // important for our filtering of deep items
                    })
                    $scope.crossfilterData.add(result.rows);
                    $scope.updatedSwimLaneData(result.rows, true);
                })
            }
        }
        $scope.$on('$destroy', function () {
           socket.disconnect();
        });
    })

    $scope.description = function (d, e) {
        let that = this;
        // data
        var sentences = d.split(". ");
        if (e) {
             $scope.mTitle
        } else {
            return $location.$$search.ioc;
        }
        that.data = sentences;
        that.title = e;
        ngDialog.open({
            template: require('../../views/ioc_notifications/modal_desc.html'),
            plain: true,
            appendTo: '.page-content',
            scope: that,
        });
    };

    $scope.getChildIOC = function () {
        let that = this;
        that.data = $scope.child_ioc;
        that.title = "Child ID Information";
        ngDialog.open({
            template: require('../../views/ioc_notifications/modal_showall.html'),
            plain: true,
            appendTo: '.page-content',
            scope: that,
        });
    };

    var descInstanceCtrl = function ($scope, $modalInstance, data, ioc) {
        $scope.ok = function () {
            $modalInstance.close();
        };
        $scope.data = data;
        $scope.iocc = ioc;
    };

    $scope.showHide1 = false;
    $scope.showHide2 = true;
    $scope.toggleView = function (tog1, tog2) {
        $scope.showHide1 = tog1;
        $scope.showHide2 = tog2;
    }

};

ctrl.$inject = ['$scope', '$location', 'Global', '$http', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService', 'ngDialog'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/ioc_events_drilldown.js
 **/